
import timePeriodMixins from '~/mixins/timePeriodMixins';

export default {
  name: 'AdRotationBanner',
  mixins: [timePeriodMixins],
  props: {
    bannerArray: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
      randomItem: {},
    }
  },
  computed: {},
  mounted() {
    const publishedBanners = this.bannerArray.filter(item => item.cross_selling_banner && item.cross_selling_banner?.publishedAt !== null);

    if ( publishedBanners.length > 0 ) {
      const validBanners = publishedBanners.filter((item) => {
        return this.isActivePeriod(item?.cross_selling_banner?.TimePeriod);
      })

      if ( validBanners.length > 1) {
        this.randomItem = this.weightedRandomPick(validBanners);
      }
      if ( validBanners.length == 1 ) {
        this.randomItem = validBanners[0];
      }
    }
  },

  methods: {
    weightedRandomPick(array) {
      let totalWeight = array.reduce((sum, item) => sum + item.weight, 0);
      let randomNum = Math.random() * totalWeight;
      for(let i = 0; i < array.length; i++) {
        if(randomNum < array[i].weight) {
          return array[i];
        }
        randomNum -= array[i].weight;
      }
    }
  }
}
